import './ApplicationType.css';

export const ApplicationType = ({details}) => {
    return <h1 className='applicationType'>{details.application_type}</h1>
}